import { useState } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Divider,
  Typography,
  Stack,
  MenuItem,
  Avatar,
  IconButton,
  Popover,
  Chip,
  Grid,
  Paper,
} from '@mui/material';
// mocks_
import logoImage from '../../../media/corporate.png';
import account from '../../../_mock/account';

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const navigate = useNavigate();

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleLogout = () => {
    navigate('/');
    sessionStorage.clear();
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          zIndex: 1500,
          ...(open && {
            '&:before': {
              zIndex: 1500,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              // bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        {/* <Avatar src={account.photoURL} alt="photoURL" /> */}
        <Chip
          avatar={<Avatar alt="Admin" src={account.photoURL} />}
          label={sessionStorage.getItem('User_Name')}
          variant="outlined"
          size="medium"
        />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        // anchorOrigin={{
        //   vertical: 'top',
        //   horizontal: 'center',
        // }}
        // transformOrigin={{
        //   vertical: 'bottom',
        //   horizontal: 'center',
        // }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            // mt: 1.5,
            // ml: 0.75,
            // width: 180,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
              zIndex: 25000,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {sessionStorage.getItem('User_Name')}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {sessionStorage.getItem('User_EMail')}
          </Typography>
        </Box>
        <Divider>Company</Divider>
        <Grid container width={'100%'}>
          <Grid item xs={12} component={Paper} sx={{ backgroundColor: 'inherit', p: 1 }} elevation={0}>
            <Grid container>
              {/* <Grid item xs={2} justifyContent={'center'} alignItems={'center'}>
                <Stack justifyContent={'center'} alignItems={'center'} width={'100%'}>
                  <img
                    src={logoImage}
                    style={{
                      objectFit: 'contain',
                      maxWidth: '30px',
                    }}
                    alt="techveel logo"
                  />
                </Stack>
              </Grid> */}
              <Grid item xs={12} justifyContent={'center'} alignItems={'center'}>
                <Stack
                  justifyContent={'center'}
                  alignItems={'flex- start'}
                  width={'100%'}
                  height={'100%'}
                  // sx={{ borderLeft: '1px solid #C1D8C3' }}
                  // pl={2}
                >
                  <Typography
                    variant="body2"
                    textAlign={'center'}
                    className="font_style_headerer"
                    style={{ textTransform: 'uppercase', color: '#0D7C66' }}
                  >
                    {sessionStorage.getItem('Company_Name')}
                  </Typography>
                  <Typography
                    variant="body2"
                    textAlign={'center'}
                    className="font_style_headerer2"
                    style={{ textTransform: 'uppercase', color: '#7C93C3' }}
                  >
                    {sessionStorage.getItem('factoryName')} | {sessionStorage.getItem('FiscalYear')}
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* <Divider sx={{ borderStyle: 'dashed' }} /> */}
        {/* 
        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={handleClose}>
              {option.label}
            </MenuItem>
          ))}
        </Stack> */}

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </Popover>
    </>
  );
}
